var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"tw-grid tw-gap-4",style:({ 'grid-template-columns': 'repeat(auto-fit, minmax(148px, 1fr))'})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }